import { isEmpty } from 'lodash';
import { ProjectId } from 'api/models';
import {
  ProjectDetailTabKeys,
  ProjectFinancialsContractType,
  PROJECT_TABS,
} from 'api/project';
import { ProjectVisibility } from 'api/visibility';
import { useProjectDetail } from 'data/projects';
import { AccountFeature, useAccountFeature } from 'hooks/use-account-feature';

export const useFeatureEnabledProjectTabs = (
  financialContractType?: ProjectFinancialsContractType,
) => {
  const [isFinancialsEnabled] = useAccountFeature(AccountFeature.Financials);

  return PROJECT_TABS.filter((tab) => {
    if (tab.id === ProjectDetailTabKeys.Financials) {
      return isFinancialsEnabled && financialContractType != null;
    }

    return true;
  });
};

// Project visibility is not stored in the redux store.
export const useProjectVisibilityConfig = (
  projectId: ProjectId,
): undefined | ProjectVisibility => {
  const { data: project } = useProjectDetail(projectId);

  if (!isEmpty(project?.visibilitySettings)) {
    return project?.visibilitySettings;
  }

  return undefined;
};
